// Keep these type keys in sync with vetrina-storefront's components/blocks/BlockTypes.js —
// the CMS writes blocks with this shape and the storefront renders them.
export const BLOCK_TYPES = {
	TEXT: 'text',
	IMAGE: 'image',
	CATEGORY_PRODUCTS: 'category_products',
	ALL_CATEGORIES_PRODUCTS: 'all_categories_products',
};

export const BLOCK_TYPE_LABELS = {
	[BLOCK_TYPES.TEXT]: 'نص',
	[BLOCK_TYPES.IMAGE]: 'صورة',
	[BLOCK_TYPES.CATEGORY_PRODUCTS]: 'منتجات تصنيف',
	[BLOCK_TYPES.ALL_CATEGORIES_PRODUCTS]: 'كل التصنيفات مع المنتجات',
};

export const DEFAULT_BLOCK_DATA = {
	[BLOCK_TYPES.TEXT]: {text: '', align: 'start', size: 'base'},
	[BLOCK_TYPES.IMAGE]: {src: '', alt: '', href: ''},
	[BLOCK_TYPES.CATEGORY_PRODUCTS]: {categoryId: null, title: ''},
	[BLOCK_TYPES.ALL_CATEGORIES_PRODUCTS]: {},
};

// short, human readable summary of a block shown in the list row
export function getBlockPreviewText(block, categories = []) {
	const {type, data} = block;

	if (type === BLOCK_TYPES.TEXT) return data?.text || '(بدون نص)';
	if (type === BLOCK_TYPES.IMAGE) return data?.alt || data?.src || '(بدون صورة)';
	if (type === BLOCK_TYPES.CATEGORY_PRODUCTS) {
		const category = categories.find((c) => c.id === data?.categoryId);
		return data?.title || category?.name || '(لم يتم اختيار تصنيف)';
	}
	if (type === BLOCK_TYPES.ALL_CATEGORIES_PRODUCTS) return 'يعرض كل التصنيفات ومنتجاتها تلقائياً';

	return '';
}
